import type { FilterConditions } from './useMynaviStateMachine'

/**
 * フィルター条件を API パラメータに変換する。
 */
export function buildFilterParams(conditions: FilterConditions) {
  return {
    prefectures: conditions.prefectures.length > 0 ? conditions.prefectures : undefined,
    collegeTypes: conditions.collegeTypes.length > 0 ? conditions.collegeTypes : undefined,
    studyFieldIds: conditions.studyFieldIds.length > 0 ? conditions.studyFieldIds : undefined,
    jobCategoryIds: conditions.jobCategoryIds.length > 0 ? conditions.jobCategoryIds : undefined,
    eventDateFrom: conditions.eventDateFrom ?? undefined,
    eventDateTo: conditions.eventDateTo ?? undefined,
    wishedOnly: conditions.wishedOnly,
  }
}
